import {
    BAO_CAO_CHI_TIET_NHAP,
    BAO_CAO_CHI_TIET_XUAT,
    BAO_CAO_SO_CAN_DOI,
    BAO_CAO_THUC_HIEN_HOP_DONG,
    BAO_CAO_TONG_HOP_NHAP,
    BAO_CAO_TONG_HOP_XUAT,
    BIEN_BAN_GIAI_THE,
    CAP_SUA_CHUA,
    DANH_MUC_TOA_XE,
    DANH_MUC_VAT_TU,
    DINH_MUC_CO_DINH,
    HOP_DONG,
    KE_HOACH_SUA_CHUA,
    KHO,
    NGUOI_DUNG,
    PHIEU_NHAP_KHO,
    PHIEU_XUAT_KHO,
    TOA_XE,
    VAT_TU,
    VAT_TU_CONG_TY_DUYET,
} from "@/core/constants/permissions";
import { getUserFromLocalStorage } from "@/core/helpers/utils";
import { authGuard, PUBLIC_ROUTE_NAMES } from "@/router/guards/authGuard";
import {
    canAccessAsTicketOwner,
    type OwnerTicketMeta,
} from "@/router/guards/ownerTicketGuard";
import store from "@/store";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import ReportType from "../core/enums/ReportTypes.enums";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/trang-chu",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/trang-chu",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
      },
      {
        path: "/quan-ly/kho/danh-sach",
        name: "danh-sach-kho",
        component: () => import("@/views/crafted/pages/kho/List.vue"),
        meta: { capDonVi: [2], perm: KHO.XEM },
      },
      {
        path: "/quan-ly/kho/chi-tiet/:id",
        name: "chi-tiet-kho",
        component: () => import("@/views/crafted/pages/kho/Detail.vue"),
        meta: { perm: KHO.XEM },
      },
      {
        path: "/quan-ly/kho/tao-moi",
        name: "tao-moi-kho",
        component: () => import("@/views/crafted/pages/kho/NewWarehouse.vue"),
        meta: { perm: KHO.TAO_MOI },
      },
      {
        path: "/quan-ly/kho/:warehouseId/cap-nhat",
        name: "chinh-sua-kho",
        component: () =>
          import("@/views/crafted/pages/kho/UpdateWarehouse.vue"),
        meta: { perm: KHO.SUA },
      },
      {
        path: "/quan-ly/kho/phieu-xuat-kho/tao-moi",
        name: "tao-moi-phieu-xuat-kho",
        component: () =>
          import("@/views/crafted/pages/phieu-xuat-kho/Form.vue"),
        meta: { perm: PHIEU_XUAT_KHO.TAO_MOI },
      },
      {
        path: "/quan-ly/kho/phieu-xuat-kho/phieu-xuat-khac/tao-moi",
        name: "tao-phieu-xuat-kho-khac",
        component: () =>
          import("@/views/crafted/pages/phieu-xuat-kho/Form.vue"),
        meta: { perm: PHIEU_XUAT_KHO.TAO_MOI },
      },
      {
        path: "/quan-ly/kho/phieu-xuat-kho/thu-hoi/tao-moi",
        name: "tao-phieu-xuat-kho-thu-hoi",
        component: () =>
          import("@/views/crafted/pages/phieu-xuat-kho/Form.vue"),
        meta: { perm: PHIEU_XUAT_KHO.TAO_MOI },
      },
      {
        path: "/quan-ly/nhap-kho/danh-sach",
        name: "danh-sach-quan-ly-nhap-kho",
        component: () =>
          import("@/views/crafted/pages/quan-ly-nhap-kho/List.vue"),
        meta: { capDonVi: [2], perm: PHIEU_NHAP_KHO.XEM },
      },
      {
        path: "/quan-ly/nhap-kho/tao-moi",
        name: "tao-moi-quan-ly-nhap-kho",
        component: () =>
          import("@/views/crafted/pages/quan-ly-nhap-kho/Create.vue"),
        meta: { capDonVi: [2], perm: PHIEU_NHAP_KHO.TAO_MOI },
      },
      {
        path: "/quan-ly/kho/phieu-nhap-kho/phieu-nhap-khac/tao-moi",
        name: "tao-phieu-nhap-kho-khac",
        component: () =>
          import("@/views/crafted/pages/phieu-nhap-kho/Form.vue"),
        meta: { perm: PHIEU_NHAP_KHO.TAO_MOI },
      },
      {
        path: "/quan-ly/kho/phieu-nhap-kho/tao-moi",
        name: "tao-moi-phieu-nhap-kho",
        component: () =>
          import("@/views/crafted/pages/phieu-nhap-kho/Form.vue"),
        meta: { perm: PHIEU_NHAP_KHO.TAO_MOI },
      },
      // DEPRECATED: legacy phieu-nhap-kho / phieu-xuat-kho URL aliases — remove after ~2026-Q3
      {
        path: "/quan-ly/kho/phieu-xuat-kho/tam-xuat/tao-moi",
        redirect: (to) => ({
          path: "/quan-ly/kho/phieu-xuat-kho/phieu-xuat-khac/tao-moi",
          query: to.query,
        }),
      },
      {
        path: "/quan-ly/kho/phieu-nhap-kho/tam-nhap/tao-moi",
        redirect: (to) => ({
          path: "/quan-ly/kho/phieu-nhap-kho/phieu-nhap-khac/tao-moi",
          query: to.query,
        }),
      },
      {
        path: "/quan-ly/kho/:idKho/tao-phieu-tam-nhap",
        redirect: (to) => ({
          path: "/quan-ly/kho/phieu-nhap-kho/phieu-nhap-khac/tao-moi",
          query: { ...to.query, idKho: String(to.params.idKho) },
        }),
      },
      {
        path: "/quan-ly/kho/:idKho/phieu-tam-nhap/chinh-sua/:idPhieuNhap",
        redirect: (to) => ({
          path: `/quan-ly/phieu-nhap-kho/cap-nhat/${to.params.idPhieuNhap}`,
          query: to.query,
        }),
      },
      {
        path: "/quan-ly/hop-dong/:idHopDong/tao-phieu-nhap-kho",
        redirect: (to) => ({
          path: "/quan-ly/kho/phieu-nhap-kho/tao-moi",
          query: { ...to.query, idHopDong: String(to.params.idHopDong) },
        }),
      },
      {
        path: "/quan-ly/hop-dong/:idHopDong/tao-bbkn",
        redirect: (to) => ({
          path: "/quan-ly/kho/phieu-nhap-kho/tao-moi",
          query: { ...to.query, idHopDong: String(to.params.idHopDong) },
        }),
      },
      {
        path: "/quan-ly/hop-dong/:idHopDong/tao-bbkn-v2",
        redirect: (to) => ({
          path: "/quan-ly/kho/phieu-nhap-kho/tao-moi",
          query: { ...to.query, idHopDong: String(to.params.idHopDong) },
        }),
      },
      {
        path: "/quan-ly/hop-dong/:idHopDong/bien-ban/:idBienBan/phieu-nhap-kho/:idPhieuNhap/chinh-sua",
        redirect: (to) => ({
          path: `/quan-ly/phieu-nhap-kho/cap-nhat/${to.params.idPhieuNhap}`,
          query: to.query,
        }),
      },
      {
        path: "/quan-ly/kho/:idKho/hop-dong/:idHopDong/phieu-nhap-kho/chinh-sua/:idPhieuNhap",
        redirect: (to) => ({
          path: `/quan-ly/phieu-nhap-kho/cap-nhat/${to.params.idPhieuNhap}`,
          query: to.query,
        }),
      },
      {
        path: "/quan-ly/danh-muc-vat-tu",
        name: "danh-sach-danh-muc-vat-tu",
        component: () =>
          import("@/views/crafted/pages/danh-muc-vat-tu/List.vue"),
        meta: { perm: DANH_MUC_VAT_TU.XEM },
      },
      {
        path: "/quan-ly/danh-muc-vat-tu/xem-danh-sach",
        name: "xem-danh-sach-danh-muc-vat-tu",
        component: () =>
          import("@/views/crafted/pages/danh-muc-vat-tu/Viewer.vue"),
        meta: {
          hideToolbar: true,
          fullscreen: true,
          perm: DANH_MUC_VAT_TU.XEM,
        },
      },
      {
        path: "/quan-ly/danh-muc-vat-tu/chi-tiet/:id",
        name: "chi-tiet-danh-muc-vat-tu",
        component: () =>
          import("@/views/crafted/pages/danh-muc-vat-tu/Detail.vue"),
        meta: { perm: DANH_MUC_VAT_TU.XEM },
      },
      {
        path: "/quan-ly/danh-muc-vat-tu/tao-moi",
        name: "tao-moi-danh-muc-vat-tu",
        component: () =>
          import("@/views/crafted/pages/danh-muc-vat-tu/Form.vue"),
        meta: { perm: DANH_MUC_VAT_TU.TAO_MOI },
      },
      {
        path: "/quan-ly/danh-muc-vat-tu/cap-nhat/:id",
        name: "chinh-sua-danh-muc-vat-tu",
        component: () =>
          import("@/views/crafted/pages/danh-muc-vat-tu/Form.vue"),
        meta: { perm: DANH_MUC_VAT_TU.SUA },
      },
      {
        // Legacy path — redirect to /cap-nhat/:id
        path: "/quan-ly/danh-muc-vat-tu/:id/cap-nhat",
        redirect: (to) => ({
          name: "chinh-sua-danh-muc-vat-tu",
          params: { id: to.params.id },
        }),
      },
      {
        path: "/quan-ly/vat-tu/danh-sach",
        name: "supplies",
        component: () => import("@/views/crafted/pages/vat-tu/List.vue"),
        meta: { perm: VAT_TU.XEM },
      },
      {
        path: "/quan-ly/vat-tu/tao-moi",
        name: "tao-moi-vat-tu",
        component: () => import("@/views/crafted/pages/vat-tu/FormV2.vue"),
        meta: { perm: VAT_TU.TAO_MOI },
      },
      {
        path: "/quan-ly/vat-tu/cap-nhat/:id",
        name: "cap-nhat-vat-tu",
        component: () => import("@/views/crafted/pages/vat-tu/FormV2.vue"),
        meta: { perm: VAT_TU.SUA },
      },
      {
        path: "/quan-ly/vat-tu/chi-tiet/:id",
        name: "supply-detail",
        component: () => import("@/views/crafted/pages/vat-tu/Supply.vue"),
        meta: { perm: VAT_TU.XEM },
      },
      {
        path: "/quan-ly/vat-tu/xem-danh-sach/:idDmVatTu",
        name: "xem-danh-sach-vat-tu",
        component: () => import("@/views/crafted/pages/vat-tu/Viewer.vue"),
        meta: { hideToolbar: true, fullscreen: true, perm: VAT_TU.XEM },
      },
      {
        path: "/quan-ly/hop-dong/danh-sach",
        name: "danh-sach-hop-dong",
        component: () => import("@/views/crafted/pages/hop-dong/List.vue"),
        meta: { capDonVi: [2], perm: HOP_DONG.XEM },
      },
      {
        path: "/quan-ly/hop-dong/xem-danh-sach",
        name: "xem-danh-sach-hop-dong",
        component: () =>
          import("@/views/crafted/pages/hop-dong/ListViewer.vue"),
        meta: {
          hideToolbar: true,
          fullscreen: true,
          capDonVi: [2],
          perm: HOP_DONG.XEM,
        },
      },
      {
        path: "/quan-ly/hop-dong/chi-tiet/:id",
        name: "chi-tiet-hop-dong",
        component: () => import("@/views/crafted/pages/hop-dong/Detail.vue"),
        meta: { perm: HOP_DONG.XEM },
      },
      {
        path: "/quan-ly/hop-dong/tao-moi",
        name: "tao-moi-hop-dong",
        component: () => import("@/views/crafted/pages/hop-dong/Form.vue"),
        meta: { perm: HOP_DONG.TAO_MOI },
      },
      {
        path: "/quan-ly/hop-dong/cap-nhat/:id",
        name: "chinh-sua-hop-dong",
        component: () => import("@/views/crafted/pages/hop-dong/Form.vue"),
        meta: { perm: HOP_DONG.SUA },
      },
      {
        path: "/quan-ly/hop-dong/xem/:id",
        name: "xem-hop-dong",
        component: () => import("@/views/crafted/pages/hop-dong/Viewer.vue"),
        meta: { hideToolbar: true, fullscreen: true, perm: HOP_DONG.XEM },
      },
      {
        path: "/quan-ly/bien-ban-kiem-nghiem/xem/:id",
        name: "xem-bien-ban-kiem-nghiem",
        component: () =>
          import("@/views/crafted/pages/bien-ban-kiem-nghiem/Viewer.vue"),
        meta: { hideToolbar: true, fullscreen: true, perm: PHIEU_NHAP_KHO.XEM },
      },
      {
        path: "/quan-ly/phieu-nhap-kho/xem/:id",
        name: "xem-phieu-nhap-kho",
        component: () =>
          import("@/views/crafted/pages/phieu-nhap-kho/Viewer.vue"),
        meta: { hideToolbar: true, fullscreen: true, perm: PHIEU_NHAP_KHO.XEM },
      },
      {
        path: "/quan-ly/phieu-xuat-kho/xem/:id",
        name: "xem-phieu-xuat-kho",
        component: () =>
          import("@/views/crafted/pages/phieu-xuat-kho/Viewer.vue"),
        meta: { hideToolbar: true, fullscreen: true, perm: PHIEU_XUAT_KHO.XEM },
      },
      {
        path: "/quan-ly/toa-xe/danh-sach",
        name: "danh-sach-toa-xe",
        component: () => import("@/views/crafted/pages/toa-xe/List.vue"),
        meta: { perm: TOA_XE.XEM },
      },
      {
        path: "/quan-ly/toa-xe/xem-danh-sach/:idDmToaXe",
        name: "xem-danh-sach-toa-xe",
        component: () => import("@/views/crafted/pages/toa-xe/Viewer.vue"),
        meta: { hideToolbar: true, fullscreen: true, perm: TOA_XE.XEM },
      },
      {
        path: "/quan-ly/toa-xe/:id/chi-tiet",
        name: "chi-tiet-toa-xe",
        component: () => import("@/views/crafted/pages/toa-xe/Detail.vue"),
        meta: { perm: TOA_XE.XEM },
      },
      {
        path: "/quan-ly/toa-xe/:id/chinh-sua",
        name: "toa-xe-cap-nhat",
        component: () => import("@/views/crafted/pages/toa-xe/Form.vue"),
        meta: { perm: TOA_XE.SUA },
      },
      {
        path: "/quan-ly/toa-xe/tao-moi",
        name: "toa-xe-tao-moi",
        component: () => import("@/views/crafted/pages/toa-xe/Form.vue"),
        meta: { perm: TOA_XE.TAO_MOI },
      },
      {
        path: "/quan-ly/danh-muc-toa-xe/danh-sach",
        name: "danh-muc-toa-xe",
        component: () =>
          import("@/views/crafted/pages/danh-muc-toa-xe/List.vue"),
        meta: { perm: DANH_MUC_TOA_XE.XEM },
      },
      {
        path: "/quan-ly/danh-muc-toa-xe/xem-danh-sach",
        name: "xem-danh-sach-danh-muc-toa-xe",
        component: () =>
          import("@/views/crafted/pages/danh-muc-toa-xe/Viewer.vue"),
        meta: {
          hideToolbar: true,
          fullscreen: true,
          perm: DANH_MUC_TOA_XE.XEM,
        },
      },
      {
        path: "/quan-ly/danh-muc-toa-xe/tao-moi",
        name: "danh-muc-toa-xe-tao-moi",
        component: () =>
          import("@/views/crafted/pages/danh-muc-toa-xe/Form.vue"),
        meta: { perm: DANH_MUC_TOA_XE.TAO_MOI },
      },
      {
        path: "/quan-ly/danh-muc-toa-xe/cap-nhat/:id",
        name: "danh-muc-toa-xe-chinh-sua",
        component: () =>
          import("@/views/crafted/pages/danh-muc-toa-xe/Form.vue"),
        meta: { perm: DANH_MUC_TOA_XE.SUA },
      },
      {
        // Legacy path — redirect to /cap-nhat/:id
        path: "/quan-ly/danh-muc-toa-xe/:id/chinh-sua",
        redirect: (to) => ({
          name: "danh-muc-toa-xe-chinh-sua",
          params: { id: to.params.id },
        }),
      },
      {
        path: "/quan-ly/danh-muc-toa-xe/chi-tiet/:id",
        name: "chi-tiet-danh-muc-toa-xe",
        component: () =>
          import("@/views/crafted/pages/danh-muc-toa-xe/Detail.vue"),
        meta: { perm: DANH_MUC_TOA_XE.XEM },
      },
      {
        // Legacy path — redirect to /chi-tiet/:id
        path: "/quan-ly/danh-muc-toa-xe/:id/chi-tiet/",
        redirect: (to) => ({
          name: "chi-tiet-danh-muc-toa-xe",
          params: { id: to.params.id },
        }),
      },

      {
        path: "/quan-ly/bien-ban-giai-the/danh-sach",
        name: "danh-sach-bien-ban-giai-the",
        component: () =>
          import("@/views/crafted/pages/bien-ban-giai-the/Index.vue"),
        meta: { capDonVi: [2], perm: BIEN_BAN_GIAI_THE.XEM },
      },

      {
        path: "/quan-ly/bien-ban-giai-the/tao-moi",
        name: "tao-moi-bien-ban-giai-the-le",
        component: () =>
          import("@/views/crafted/pages/bien-ban-giai-the/Form.vue"),
        meta: { perm: BIEN_BAN_GIAI_THE.TAO_MOI },
      },

      {
        path: "/quan-ly/ke-hoach-sua-chua/:idKeHoach/bien-ban-giai-the/tao-moi",
        name: "tao-moi-bien-ban-giai-the",
        component: () =>
          import("@/views/crafted/pages/bien-ban-giai-the/Form.vue"),
        meta: { perm: BIEN_BAN_GIAI_THE.TAO_MOI },
      },

      {
        path: "/quan-ly/ke-hoach-nam/:idKeHoach/bien-ban-giai-the/tao-moi",
        name: "tao-moi-bien-ban-giai-the-ke-hoach-nam",
        component: () =>
          import("@/views/crafted/pages/bien-ban-giai-the/Form.vue"),
        meta: { perm: BIEN_BAN_GIAI_THE.TAO_MOI },
      },

      // dissolution report
      {
        path: "/quan-ly/bien-ban-giai-the/chi-tiet/:id",
        name: "chi-tiet-bien-ban-giai-the",
        component: () =>
          import("@/views/crafted/pages/bien-ban-giai-the/Detail.vue"),
        meta: { perm: BIEN_BAN_GIAI_THE.XEM },
      },
      {
        path: "/quan-ly/bien-ban-giai-the/xem/:id",
        name: "xem-bien-ban-giai-the",
        component: () =>
          import("@/views/crafted/pages/bien-ban-giai-the/Viewer.vue"),
        meta: {
          hideToolbar: true,
          fullscreen: true,
          perm: BIEN_BAN_GIAI_THE.XEM,
        },
      },
      {
        path: "/quan-ly/bien-ban-giai-the/cap-nhat/:idBienBan",
        name: "cap-nhat-bien-ban-giai-the",
        component: () =>
          import("@/views/crafted/pages/bien-ban-giai-the/Form.vue"),
        meta: { perm: BIEN_BAN_GIAI_THE.SUA },
      },
      {
        path: "/quan-ly/bien-ban-giai-the/:idBienBan/tao-bbgt-bo-sung",
        name: "tao-bbgt-bo-sung",
        component: () =>
          import("@/views/crafted/pages/bien-ban-giai-the/Form.vue"),
        meta: { perm: BIEN_BAN_GIAI_THE.TAO_MOI },
      },
      {
        path: "/quan-ly/ke-hoach-sua-chua/danh-sach",
        name: "danh-sach-ke-hoach-sua-chua",
        component: () =>
          import("@/views/crafted/pages/ke-hoach-sua-chua/List.vue"),
        meta: { perm: KE_HOACH_SUA_CHUA.XEM },
      },
      {
        path: "/quan-ly/ke-hoach-sua-chua/xem-danh-sach",
        name: "xem-danh-sach-ke-hoach-sua-chua",
        component: () =>
          import("@/views/crafted/pages/ke-hoach-sua-chua/Viewer.vue"),
        meta: {
          hideToolbar: true,
          fullscreen: true,
          perm: KE_HOACH_SUA_CHUA.XEM,
        },
      },
      {
        path: "/quan-ly/ke-hoach-sua-chua/chi-tiet/:id",
        name: "chi-tiet-ke-hoach-sua-chua",
        component: () =>
          import("@/views/crafted/pages/ke-hoach-sua-chua/Detail.vue"),
        meta: { perm: KE_HOACH_SUA_CHUA.XEM },
      },
      {
        path: "/quan-ly/ke-hoach-sua-chua/tao-moi",
        name: "tao-moi-ke-hoach-sua-chua",
        component: () =>
          import("@/views/crafted/pages/ke-hoach-sua-chua/Form.vue"),
        meta: { perm: KE_HOACH_SUA_CHUA.TAO_MOI },
      },
      {
        path: "/quan-ly/ke-hoach-sua-chua/chinh-sua/:id",
        name: "chinh-sua-ke-hoach-sua-chua",
        component: () =>
          import("@/views/crafted/pages/ke-hoach-sua-chua/Form.vue"),
        meta: { perm: KE_HOACH_SUA_CHUA.SUA },
      },
      {
        path: "/quan-ly/ke-hoach-nam/danh-sach",
        name: "danh-sach-ke-hoach-nam",
        component: () => import("@/views/crafted/pages/ke-hoach-nam/List.vue"),
        meta: { perm: KE_HOACH_SUA_CHUA.XEM },
      },
      {
        path: "/quan-ly/ke-hoach-nam/xem-danh-sach",
        name: "xem-danh-sach-ke-hoach-nam",
        component: () =>
          import("@/views/crafted/pages/ke-hoach-nam/Viewer.vue"),
        meta: {
          hideToolbar: true,
          fullscreen: true,
          perm: KE_HOACH_SUA_CHUA.XEM,
        },
      },
      {
        path: "/quan-ly/ke-hoach-nam/chi-tiet/:id",
        name: "chi-tiet-ke-hoach-nam",
        component: () =>
          import("@/views/crafted/pages/ke-hoach-nam/Detail.vue"),
        meta: { perm: KE_HOACH_SUA_CHUA.XEM },
      },
      {
        path: "/quan-ly/ke-hoach-nam/tao-moi",
        name: "tao-moi-ke-hoach-nam",
        component: () => import("@/views/crafted/pages/ke-hoach-nam/Form.vue"),
        meta: { perm: KE_HOACH_SUA_CHUA.TAO_MOI },
      },
      {
        path: "/quan-ly/ke-hoach-nam/chinh-sua/:id",
        name: "chinh-sua-ke-hoach-nam",
        component: () => import("@/views/crafted/pages/ke-hoach-nam/Form.vue"),
        meta: { perm: KE_HOACH_SUA_CHUA.SUA },
      },
      {
        path: "/quan-ly/phieu-xuat-kho/cap-nhat/:idPhieuXuatKho",
        name: "cap-nhat-phieu-xuat-kho-theo-bien-ban",
        component: () =>
          import("@/views/crafted/pages/phieu-xuat-kho/Form.vue"),
        meta: {
          perm: PHIEU_XUAT_KHO.SUA,
          ownerTicket: { resource: "pxk", param: "idPhieuXuatKho" },
        },
      },
      {
        path: "/quan-ly/phieu-xuat-kho/phieu-xuat-khac/cap-nhat/:id",
        name: "cap-nhat-phieu-xuat-kho-khac",
        component: () =>
          import("@/views/crafted/pages/phieu-xuat-kho/Form.vue"),
        meta: {
          perm: PHIEU_XUAT_KHO.SUA,
          ownerTicket: { resource: "pxk", param: "id" },
        },
      },
      {
        path: "/quan-ly/phieu-xuat-kho/tam-xuat/cap-nhat/:id",
        redirect: (to) => ({
          path: `/quan-ly/phieu-xuat-kho/phieu-xuat-khac/cap-nhat/${to.params.id}`,
          query: to.query,
        }),
      },
      {
        path: "/quan-ly/phieu-xuat-kho/thu-hoi/cap-nhat/:id",
        name: "cap-nhat-phieu-xuat-kho-thu-hoi",
        component: () =>
          import("@/views/crafted/pages/phieu-xuat-kho/Form.vue"),
        meta: {
          perm: PHIEU_XUAT_KHO.SUA,
          ownerTicket: { resource: "pxk", param: "id" },
        },
      },
      {
        path: "/quan-ly/phieu-xuat-kho/chi-tiet/:idPhieuXuatKho",
        name: "chi-tiet-phieu-xuat-kho",
        component: () =>
          import("@/views/crafted/pages/phieu-xuat-kho/Detail.vue"),
        meta: { perm: PHIEU_XUAT_KHO.XEM },
      },
      {
        path: "/quan-ly/bao-cao/xem/:reportType",
        name: "xem-bao-cao",
        component: () => import("@/views/crafted/pages/bao-cao/Viewer.vue"),
        meta: { hideToolbar: true, fullscreen: true },
      },
      {
        path: `/quan-ly/bao-cao/${ReportType.SO_CAN_DOI_VAT_TU}`,
        name: ReportType.SO_CAN_DOI_VAT_TU,
        component: () =>
          import("@/views/crafted/pages/bao-cao/SoCanDoiVatTu.vue"),
        meta: { perm: BAO_CAO_SO_CAN_DOI.XEM },
      },
      {
        path: `/quan-ly/bao-cao/${ReportType.BANG_KE_CHI_TIET_NHAP}`,
        name: ReportType.BANG_KE_CHI_TIET_NHAP,
        component: () =>
          import("@/views/crafted/pages/bao-cao/BangKeChiTietNhap.vue"),
        meta: { perm: BAO_CAO_CHI_TIET_NHAP.XEM },
      },
      {
        path: `/quan-ly/bao-cao/${ReportType.BANG_KE_CHI_TIET_XUAT}`,
        name: ReportType.BANG_KE_CHI_TIET_XUAT,
        component: () =>
          import("@/views/crafted/pages/bao-cao/BangKeChiTietXuat.vue"),
        meta: { perm: BAO_CAO_CHI_TIET_XUAT.XEM },
      },
      {
        path: `/quan-ly/bao-cao/${ReportType.TONG_HOP_NHAP_VAT_TU}`,
        name: ReportType.TONG_HOP_NHAP_VAT_TU,
        component: () =>
          import("@/views/crafted/pages/bao-cao/TongHopVatTu.vue"),
        meta: { perm: BAO_CAO_TONG_HOP_NHAP.XEM },
      },
      {
        path: `/quan-ly/bao-cao/${ReportType.TONG_HOP_XUAT_VAT_TU}`,
        name: ReportType.TONG_HOP_XUAT_VAT_TU,
        component: () =>
          import("@/views/crafted/pages/bao-cao/TongHopVatTu.vue"),
        meta: { perm: BAO_CAO_TONG_HOP_XUAT.XEM },
      },
      {
        path: `/quan-ly/bao-cao/${ReportType.CHI_TIET_XUAT_THEO_DOI_TUONG}`,
        name: ReportType.CHI_TIET_XUAT_THEO_DOI_TUONG,
        component: () =>
          import("@/views/crafted/pages/bao-cao/KeHoachChiPhi.vue"),
        meta: { perm: BAO_CAO_CHI_TIET_XUAT.XEM },
      },
      {
        path: `/quan-ly/bao-cao/${ReportType.THEO_DOI_THUC_HIEN_HOP_DONG}`,
        name: ReportType.THEO_DOI_THUC_HIEN_HOP_DONG,
        component: () =>
          import("@/views/crafted/pages/bao-cao/TheoDoiHopDong.vue"),
        meta: { perm: BAO_CAO_THUC_HIEN_HOP_DONG.XEM },
      },
      {
        path: `/quan-ly/bao-cao/${ReportType.THEO_DOI_VTPT_THU_HOI}`,
        name: ReportType.THEO_DOI_VTPT_THU_HOI,
        component: () =>
          import("@/views/crafted/pages/bao-cao/TheoDoiVtptThuHoi.vue"),
        meta: { capDonVi: [2] },
      },
      {
        path: `/quan-ly/bao-cao/${ReportType.TONG_HOP_VAT_TU_THEO_DOI_TUONG}`,
        name: ReportType.TONG_HOP_VAT_TU_THEO_DOI_TUONG,
        component: () =>
          import("@/views/crafted/pages/bao-cao/TongHopVatTuTheoDoiTuong.vue"),
        meta: { perm: BAO_CAO_TONG_HOP_XUAT.XEM },
      },
      // Company-level reports (cap_don_vi = 1)
      {
        path: `/quan-ly/bao-cao/${ReportType.NHAP_XUAT_TON_KHO}`,
        name: ReportType.NHAP_XUAT_TON_KHO,
        component: () =>
          import("@/views/crafted/pages/bao-cao/NhapXuatTonKho.vue"),
        meta: { capDonVi: [1] },
      },
      {
        path: `/quan-ly/bao-cao/${ReportType.NHAP_KHO_VAT_TU_PHU_TUNG}`,
        name: ReportType.NHAP_KHO_VAT_TU_PHU_TUNG,
        component: () =>
          import("@/views/crafted/pages/bao-cao/NhapKhoVatTuPhuTung.vue"),
        meta: { capDonVi: [1] },
      },
      {
        path: `/quan-ly/bao-cao/${ReportType.GIA_THANH_SUA_CHUA_CAC_CAP}`,
        name: ReportType.GIA_THANH_SUA_CHUA_CAC_CAP,
        component: () =>
          import("@/views/crafted/pages/bao-cao/GiaThanhSuaChuaCacCap.vue"),
        meta: { capDonVi: [1] },
      },
      {
        path: "/quan-ly/dinh-muc-co-dinh/danh-sach",
        name: "danh-sach-dinh-muc-co-dinh",
        component: () =>
          import("@/views/crafted/pages/dinh-muc-co-dinh/List.vue"),
        meta: { capDonVi: [1], perm: DINH_MUC_CO_DINH.XEM },
      },
      {
        path: "/quan-ly/dinh-muc-co-dinh/xem-danh-sach",
        name: "xem-danh-sach-dinh-muc-co-dinh",
        component: () =>
          import("@/views/crafted/pages/dinh-muc-co-dinh/Viewer.vue"),
        meta: {
          hideToolbar: true,
          fullscreen: true,
          perm: DINH_MUC_CO_DINH.XEM,
        },
      },
      {
        path: "/quan-ly/dinh-muc-co-dinh/tao-moi",
        name: "tao-moi-dinh-muc-co-dinh",
        component: () =>
          import("@/views/crafted/pages/dinh-muc-co-dinh/Form.vue"),
        meta: { perm: DINH_MUC_CO_DINH.TAO_MOI },
      },
      {
        path: "/quan-ly/dinh-muc-co-dinh/chi-tiet/:id",
        name: "chi-tiet-dinh-muc-co-dinh",
        component: () =>
          import("@/views/crafted/pages/dinh-muc-co-dinh/Detail.vue"),
        meta: { perm: DINH_MUC_CO_DINH.XEM },
      },
      {
        path: "/quan-ly/dinh-muc-co-dinh/chinh-sua/:id",
        name: "chinh-sua-dinh-muc-co-dinh",
        component: () =>
          import("@/views/crafted/pages/dinh-muc-co-dinh/Form.vue"),
        meta: { perm: DINH_MUC_CO_DINH.SUA },
      },
      {
        path: "/quan-ly/cap-sua-chua/danh-sach",
        name: "danh-sach-cap-sua-chua",
        component: () => import("@/views/crafted/pages/cap-sua-chua/List.vue"),
        meta: { capDonVi: [1], perm: CAP_SUA_CHUA.XEM },
      },
      {
        path: "/quan-ly/cap-sua-chua/xem-danh-sach",
        name: "xem-danh-sach-cap-sua-chua",
        component: () =>
          import("@/views/crafted/pages/cap-sua-chua/Viewer.vue"),
        meta: {
          hideToolbar: true,
          fullscreen: true,
          capDonVi: [1],
          perm: CAP_SUA_CHUA.XEM,
        },
      },
      {
        path: "/quan-ly/cap-sua-chua/tao-moi",
        name: "tao-moi-cap-sua-chua",
        component: () => import("@/views/crafted/pages/cap-sua-chua/Form.vue"),
        meta: { perm: CAP_SUA_CHUA.TAO_MOI },
      },
      {
        path: "/quan-ly/cap-sua-chua/chi-tiet/:id",
        name: "chi-tiet-cap-sua-chua",
        component: () =>
          import("@/views/crafted/pages/cap-sua-chua/Detail.vue"),
        meta: { perm: CAP_SUA_CHUA.XEM },
      },
      {
        path: "/quan-ly/cap-sua-chua/chinh-sua/:id",
        name: "chinh-sua-cap-sua-chua",
        component: () => import("@/views/crafted/pages/cap-sua-chua/Form.vue"),
        meta: { perm: CAP_SUA_CHUA.SUA },
      },
      {
        path: "/quan-ly/phieu-nhap-kho/cap-nhat/:id",
        name: "cap-nhat-phieu-nhap-kho",
        component: () =>
          import("@/views/crafted/pages/phieu-nhap-kho/Form.vue"),
        meta: {
          perm: PHIEU_NHAP_KHO.SUA,
          ownerTicket: { resource: "pnk", param: "id" },
        },
      },
      {
        path: "/quan-ly/phieu-nhap-kho/chi-tiet/:idPhieuNhapKho",
        name: "chi-tiet-phieu-nhap-kho",
        component: () =>
          import("@/views/crafted/pages/phieu-nhap-kho/Detail.vue"),
        meta: { perm: PHIEU_NHAP_KHO.XEM },
      },
      {
        path: "/quan-ly/bo-phan/danh-sach",
        name: "part-list",
        component: () => import("@/views/crafted/pages/part/Index.vue"),
      },
      {
        path: "/quan-ly/bo-phan/tao-moi",
        name: "new-part-form",
        component: () => import("@/views/crafted/pages/part/Form.vue"),
      },
      {
        path: "/quan-ly/bo-phan/chi-tiet/:id",
        name: "part-detail",
        component: () => import("@/views/crafted/pages/part/Detail.vue"),
      },
      {
        path: "/quan-ly/bo-phan/cap-nhat/:id",
        name: "edit-part-form",
        component: () => import("@/views/crafted/pages/part/Form.vue"),
      },
      {
        path: "/quan-ly/chuc-vu/danh-sach",
        name: "positions-index",
        component: () => import("@/views/crafted/pages/positions/Index.vue"),
      },
      {
        path: "/quan-ly/chuc-vu/tao-moi",
        name: "new-position-form",
        component: () => import("@/views/crafted/pages/positions/Form.vue"),
      },
      {
        path: "/quan-ly/chuc-vu/cap-nhat/:id",
        name: "edit-position-form",
        component: () => import("@/views/crafted/pages/positions/Form.vue"),
      },
      {
        path: "/quan-ly/chuc-vu/chi-tiet/:id",
        name: "position-detail",
        component: () => import("@/views/crafted/pages/positions/Detail.vue"),
      },
      {
        path: "/crafted/pages/profile",
        name: "profile",
        component: () => import("@/components/page-layouts/Profile.vue"),
        children: [
          {
            path: "overview",
            name: "profile-overview",
            component: () =>
              import("@/views/crafted/pages/profile/Overview.vue"),
          },
        ],
      },
      // Duyệt
      {
        path: "/duyet/danh-sach/vat-tu",
        name: "danh-sach-vat-tu-chua-duyet",
        component: () => import("@/views/crafted/pages/duyet/vat-tu/List.vue"),
        meta: { perm: VAT_TU.DUYET },
      },
      {
        path: "/duyet/danh-sach/phieu-xuat-kho",
        name: "danh-sach-phieu-xuat-kho-chua-duyet",
        component: () =>
          import("@/views/crafted/pages/duyet/phieu-xuat-kho/List.vue"),
        meta: {
          perm: PHIEU_XUAT_KHO.DUYET,
        },
      },
      {
        path: "/duyet/danh-sach/phieu-nhap-kho",
        name: "danh-sach-phieu-nhap-kho-chua-duyet",
        component: () =>
          import("@/views/crafted/pages/duyet/phieu-nhap-kho/List.vue"),
        meta: {
          perm: PHIEU_NHAP_KHO.DUYET,
        },
      },
      {
        path: "/duyet/danh-sach/bien-ban-giai-the",
        name: "danh-sach-bien-ban-giai-the-cho-duyet",
        component: () =>
          import("@/views/crafted/pages/duyet/bien-ban-giai-the/List.vue"),
        meta: {
          permAny: [BIEN_BAN_GIAI_THE.XAC_NHAN, BIEN_BAN_GIAI_THE.DUYET],
        },
      },
      {
        path: "/duyet/ngoai-dinh-muc",
        name: "duyet-ngoai-dinh-muc",
        component: () =>
          import("@/views/crafted/pages/duyet/ngoai-dinh-muc/List.vue"),
        meta: { perm: VAT_TU_CONG_TY_DUYET.DUYET },
      },
      {
        path: "/quan-ly/quyen-han-va-chuc-vu",
        name: "roles-and-permissions",
        component: () => import("@/views/crafted/pages/positions/Detail.vue"),
        meta: { perm: NGUOI_DUNG.XEM },
      },
      {
        path: "/quan-ly/nguoi-dung/danh-sach",
        name: "danh-sach-nguoi-dung",
        component: () => import("@/views/crafted/pages/nguoi-dung/List.vue"),
        meta: { perm: NGUOI_DUNG.XEM },
      },
      {
        path: "/quan-ly/don-vi/danh-sach",
        name: "danh-sach-don-vi",
        component: () => import("@/views/crafted/pages/don-vi/List.vue"),
        meta: { capDonVi: [1] },
      },
      {
        path: "/quan-ly/nguoi-dung/tao-moi",
        name: "nguoi-dung-tao-moi",
        component: () => import("@/views/crafted/pages/nguoi-dung/Form.vue"),
        meta: { perm: NGUOI_DUNG.TAO_MOI },
      },
      {
        path: "/quan-ly/nguoi-dung/cap-nhat/:id",
        name: "nguoi-dung-cap-nhat",
        component: () => import("@/views/crafted/pages/nguoi-dung/Form.vue"),
        meta: { perm: NGUOI_DUNG.SUA },
      },
      {
        path: "/quan-ly/cau-hinh",
        name: "cau-hinh-he-thong",
        component: () => import("@/views/crafted/pages/cau-hinh/Index.vue"),
      },
      {
        path: "/quan-ly/tai-khoan/thong-tin",
        name: "thong-tin-nguoi-dung-hien-tai",
        component: () => import("@/views/crafted/pages/tai-khoan/Detail.vue"),
      },
      {
        path: "/quan-ly/tai-khoan/cap-nhat",
        name: "cap-nhat-thong-tin-nguoi-dung-hien-tai",
        component: () => import("@/views/crafted/pages/tai-khoan/Form.vue"),
      },
      {
        path: "/quan-ly/roles/danh-sach",
        name: "danh-sach-roles",
        component: () => import("@/views/crafted/pages/roles/List.vue"),
        meta: { perm: NGUOI_DUNG.XEM },
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
      },
    ],
  },
  {
    path: "/401",
    name: "401",
    component: () => import("@/views/crafted/authentication/Error401.vue"),
  },
  {
    path: "/403",
    name: "403",
    component: () => import("@/views/crafted/authentication/Error403.vue"),
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/crafted/authentication/Error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const user = getUserFromLocalStorage();
  if (user) {
    store.commit(Mutations.SET_USER, user);
    await store.dispatch(Actions.INIT_USER_SYSTEM_SETTINGS);
  }

  const authRedirect = authGuard(to);
  if (authRedirect) {
    return next(authRedirect);
  }

  const routeName = to.name as string | undefined;
  const isPublicRoute = routeName ? PUBLIC_ROUTE_NAMES.has(routeName) : false;

  // One /api/v1/me/abilities fetch per page entry (not per API request).
  // First entry: load if not cached. Route name change: force refresh once.
  if (user && !isPublicRoute) {
    const isNewPage = !!from.name && from.name !== to.name;
    await store.dispatch(Actions.LOAD_ABILITIES, isNewPage);
  }

  const needPerm = to.meta?.perm;
  const needPermAll = to.meta?.permAll;
  const needPermAny = to.meta?.permAny;

  if (needPerm || needPermAll || needPermAny) {
    const authzModule = (
      store.state as { AuthzModule?: { permissions: Set<string> } }
    ).AuthzModule;

    if (!authzModule || !authzModule.permissions) {
      try {
        const forbiddenRoute = router.resolve({ name: "403" });

        if (forbiddenRoute && forbiddenRoute.name === "403") {
          return next({ name: "403" });
        }
      } catch (e) {
        // NOTHING TODO
      }

      return next({ name: "404" });
    }

    const permissions = authzModule.permissions;
    let hasPermission = false;

    if (needPerm) {
      if (Array.isArray(needPerm)) {
        hasPermission = needPerm.every((perm) => permissions.has(perm));
      } else {
        hasPermission = permissions.has(needPerm as string);
      }
    } else if (needPermAll) {
      hasPermission =
        Array.isArray(needPermAll) && needPermAll.length > 0
          ? needPermAll.every((perm) => permissions.has(perm))
          : false;
    } else if (needPermAny) {
      hasPermission =
        Array.isArray(needPermAny) && needPermAny.length > 0
          ? needPermAny.some((perm) => permissions.has(perm))
          : false;
    }

    if (!hasPermission) {
      const ownerTicket = to.meta?.ownerTicket as OwnerTicketMeta | undefined;
      const isOwner =
        !!ownerTicket && (await canAccessAsTicketOwner(to, ownerTicket));

      if (!isOwner) {
        try {
          const forbiddenRoute = router.resolve({ name: "403" });
          if (forbiddenRoute && forbiddenRoute.name === "403") {
            return next({ name: "403" });
          }
        } catch (e) {
          // NOTHING TODO
        }

        return next({ name: "404" });
      }
    }
  }

  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);

  next();
});

export default router;
